/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Learn_SubtitleInputs */

const en_home_learn_subtitle = /** @type {(inputs: Home_Learn_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short, hands-on lessons you can follow in CADCraft online. Start with the command line, then move on to editing, export and automation.`)
};

/**
* | output |
* | --- |
* | "Short, hands-on lessons you can follow in CADCraft online. Start with the command line, then move on to editing, export and automation." |
*
* @param {Home_Learn_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_learn_subtitle = /** @type {((inputs?: Home_Learn_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Learn_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_learn_subtitle(inputs)
});
export { home_learn_subtitle as "home.learn.subtitle" }